import React, { FC, useEffect, useState } from 'react'
import { Button, PlusIcon, TickIcon } from 'pages/native/onBoarding/components'
import { useFollowedTeams } from 'pages/native/onBoarding/context/OnBoardingContext'
import { ChannelTeamItem } from 'pages/native/onBoarding/types/types'
import { toPascalCase } from 'helpers/stringHelper'
import { useAnalytics } from 'utils/analytics/useAnalytics'

import styles from './FollowButton.module.scss'

enum FollowState {
  Follow = 'follow',
  Following = 'following'
}

const followButtonMap = {
  [FollowState.Follow]: {
    label: toPascalCase(FollowState.Follow),
    icon: <PlusIcon />
  },
  [FollowState.Following]: {
    label: toPascalCase(FollowState.Following),
    icon: <TickIcon />
  }
}

interface FollowButtonProps {
  team: ChannelTeamItem
}

export const FollowButton: FC<FollowButtonProps> = ({ team }) => {
  const { value: followedTeams, set: setFollowedTeams } = useFollowedTeams()
  const [buttonState, setButtonState] = useState<FollowState>(
    FollowState.Follow
  )
  const { trackClarity, trackGtm } = useAnalytics()


  useEffect(() => {
    const isFollowed = followedTeams.find((item) => item.id === team.id)
    setButtonState(isFollowed ? FollowState.Following : FollowState.Follow)
  }, [followedTeams, team.id])

  const clickHandler = () => {
    const isAlreadyFollowed = followedTeams.some(item => item.id === team.id)

    if (isAlreadyFollowed) {
      const newFollowedTeams = followedTeams.filter(
        (item) => item.id !== team.id
      )
      setFollowedTeams(newFollowedTeams)
    } else {
      const newFollowedTeams = [...followedTeams, team]
      setFollowedTeams(newFollowedTeams)

      trackGtm('follow_team_selected_app', {
        team_id: team.id,
        team_name: team.name
      })
      trackClarity('follow_team_selected_app', {
        team_id: team.id,
        team_name: team.name
      })
    }
  }

  return (
    <div className={styles.FollowButton}>
      <Button
        size="small"
        onClick={clickHandler}
        variant="outlined"
        theme="primary"
        icon={followButtonMap[buttonState].icon}
        label={followButtonMap[buttonState].label}
        iconPosition="left"
      />
    </div>
  )
}
